import React, { memo } from 'react'
import { Card } from '@mui/material'

import { mergeToNewObject } from '../../../util/object.helpers'

const BaseCard = ({ children, sx, ...restProps }) => (
  <Card
    sx={mergeToNewObject(
      { height: '100%', p: { sm: 2, md: 5 }, margin: 0 },
      sx
    )}
    {...restProps}
  >
    {children}
  </Card>
)

export default memo(BaseCard)
